import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { Link, useSearch } from "@tanstack/react-router";
import { Filter } from "lucide-react";

function AppFilters() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="outline" data-testid="filterTrigger">
          <Filter size={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Filter origins</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <PublicAppFilterItem />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

function PublicAppFilterItem() {
  const { filterShowPublicApps } = useSearch({
    from: "/_auth/_fixed-sidebar/_organization-access/organization/$organizationSlug/gallery"
  });

  return (
    <Link
      from="/organization/$organizationSlug/gallery"
      to="/organization/$organizationSlug/gallery"
      data-testid="filterOption"
      search={(prev) => ({
        ...prev,
        filterShowPublicApps: filterShowPublicApps ? undefined : true
      })}
    >
      <DropdownMenuCheckboxItem checked={filterShowPublicApps}>
        Show public apps
      </DropdownMenuCheckboxItem>
    </Link>
  );
}

export default AppFilters;
